import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationsApiService } from 'src/app/services/api/applications-api.service';
import { ApplicationService } from 'src/app/services/application-service';
import { channelOptions } from 'src/configs/dropdown-options/options.se';
import { handleApiError } from 'src/app/utils/error';
import { FlowService } from 'src/app/services/flow.service';
import { Subscription } from 'rxjs';
import { TrackingService } from 'src/app/services/tracking.service';

@Component({
  selector: 'app-channel',
  templateUrl: './channel.component.html',
  styleUrls: ['./channel.component.scss'],
})
export class ChannelComponent implements OnInit, OnDestroy {
  applicationId!: number;
  channelForm!: FormGroup;
  channelOptions = channelOptions;
  error!: string;
  steps!: number;
  @Input() isSummary!: boolean;
  subs = Array<Subscription>();

  constructor(
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    private applicationService: ApplicationService,
    private applicationsApiService: ApplicationsApiService,
    public flowService: FlowService,
    protected trackingService: TrackingService
  ) {
  }

  ngOnInit(): void {
    const initialChannel = this.applicationService.customerSource;
    this.applicationId = this.applicationService.applicationId;
    this.channelForm = this.formBuilder.group({
      channel: [initialChannel, []],
    });
    this.subs.push(this.channel.valueChanges.subscribe((v) => {
      this.applicationsApiService
        .updateApplication({
          customerSource: v,
          applicationId: this.applicationId,
        })
        .subscribe(
          () => {
            this.applicationService.customerSource = v;
            this.error = '';
            this.trackFields();
          },
          (error: any) => handleApiError(error, this.translateService)
        );
    }));
  }

  ngOnDestroy(): void {
    this.subs.map((s) => s.unsubscribe());
  }

  trackFields(): void {
    this.trackingService.filledField('channel');
  }

  handleBackButtonClick(): void {
    this.flowService.previousScreen();
  }

  handleNextButtonClick(): void {
    if (this.form.invalid) {
      return;
    }
    this.flowService.nextScreen();
  }

  get form(): FormGroup {
    return this.channelForm;
  }

  get channel(): FormControl {
    return this.form.get('channel') as FormControl;
  }
}
